module.exports = __webpack_public_path__ + "static/media/hlk.25e92850.png";


//////////////////
// WEBPACK FOOTER
// ./src/Static/image/hlk.png
// module id = 1014
// module chunks = 0